import { SuccessIcon } from "assets/images";
import { FC } from "react";
import { IpropsSuccessModal } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
const SuccessModalPc: FC<IpropsSuccessModal> = ({ onClose, open, title }) => {
  return (
    <OverlayModalCommon onClose={onClose} open={open}>
      <div className="contentModalSettingsMapPc scrollbar-div">
        <div className="rowBodyModalSuccess">
          <img
            className="SuccessIconStyle"
            alt="SuccessIcon"
            src={SuccessIcon}
          />
          <div className="titleSuccessModalPc">{title}</div>
        </div>

        <div className="rowBtnSettingsMap">
          <div onClick={onClose} className="BtnSuccessSubmit pointer">
            تایید
          </div>
        </div>
      </div>
    </OverlayModalCommon>
  );
};
export default SuccessModalPc;
